import React from 'react'

//CSS Import
import "./ProdComponent.css"

//Image Import 
import prodImg from "../../../../assets/imgs/product/prodImg.jpeg" 

function ProdComponent(props) {
  return (
    <div className='prodComponent'>
        <div className='prodCompo-left'>
            <img src={prodImg} alt='Product'/>
        </div>

        <div className='prodCompo-right'>
            <h3 className='prod-name'>Fire Detector</h3>
            <p className='prod-desc'>semper quis lectus nulla at volutpat diam ut venenatis tellus in metus vulputate eu scelerisque felis imperdiet proin fermentum leo vel orci porta non pulvinar neque laoreet suspendisse interdum consectetur libero id faucibus nisl tincidunt eget nullam non nisi est</p>
            <p className='prod-price'>Estimated Price: <span style={{color:'green'}}>Rs 1800/-</span></p>
            <div className='prod-ratingStars'>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-regular fa-star"></i>
            </div>
            <button className='prod-contact'>Contact Us</button>
            <p id='closeBtn' onClick={props.handleProdClose}><i class="fa-solid fa-circle-xmark"></i></p>
        </div>
        
      
    </div>
  )
}

export default ProdComponent
